<ng-container *ngIf="!autocomplete">
  <mat-form-field
    mat-input-height-large-label
    data-at-form-field
    [floatLabel]="getFloatLabel()"
    class="bg-color-{{ bgColor }} size-{{ size }} icon-{{ iconColor }}"
    [style.width]="width"
    [class.error-state]="errorMessage && !isFocused && showError"
  >
    <mat-label>{{ placeholder }}</mat-label>
    <mat-icon data-at-prefix *ngIf="icon" matPrefix>{{ icon }}</mat-icon>
    <input
      #input
      matInput
      [maxlength]="maxInputLength"
      [type]="type"
      [disabled]="disabled"
      [required]="required"
      [(ngModel)]="value"
      (ngModelChange)="onChange($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
      fieldTextContentTooltip
    />
    <button
      data-at-close-btn
      *ngIf="value && isClearable"
      matSuffix
      mat-icon-button
      aria-label="Clear"
      (click)="clear()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
  <div
    data-at-error-message
    [class.error-message-show]="errorMessage && !isFocused && showError"
    class="error-message"
  >
    {{ errorMessage }}
  </div>
</ng-container>

<ng-container *ngIf="autocomplete">
  <mat-form-field
    mat-input-height-large-label
    data-at-form-field
    [floatLabel]="getFloatLabel()"
    class="bg-color-{{ bgColor }} size-{{ size }} icon-{{ iconColor }}"
    [style.width]="width"
    [class.error-state]="errorMessage && !isFocused && showError"
  >
    <mat-label>{{ placeholder }}</mat-label>
    <mat-icon data-at-prefix *ngIf="icon" matPrefix>{{ icon }}</mat-icon>
    <input
      #input
      matInput
      [maxlength]="maxInputLength"
      [type]="type"
      [disabled]="disabled"
      [required]="required"
      [matAutocomplete]="auto"
      [(ngModel)]="value"
      (ngModelChange)="onChange($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
      fieldTextContentTooltip
    />
    <button
      data-at-close-btn
      *ngIf="value && isClearable"
      matSuffix
      mat-icon-button
      aria-label="Clear"
      (click)="clear()"
    >
      <mat-icon>close</mat-icon>
    </button>
    <mat-autocomplete
      #auto="matAutocomplete"
      [autoActiveFirstOption]="true"
      [displayWith]="displayFn"
      (optionSelected)="onAutocompleteSelect($event)"
      (closed)="onAutocompleteClose()"
      (opened)="onAutocompleteOpen()"
    >
      <mat-option
        *ngFor="
          let option of !!maxAutocompleteLength
            ? autocompleteOptions.slice(0, maxAutocompleteLength)
            : autocompleteOptions
        "
        [value]="option"
        fieldTextContentTooltip
      >
        <ng-container *ngIf="option.column; else viewValue">
          <p class="column-option" *ngFor="let item of option.column">
            {{ item }}
          </p>
        </ng-container>
        <ng-template #viewValue>
          {{ option.viewValue }}
        </ng-template>
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <div
    data-at-error-message
    [class.error-message-show]="errorMessage && !isFocused && showError"
    class="error-message"
  >
    {{ errorMessage }}
  </div>
</ng-container>
